import React, { useState, useEffect, useRef } from "react";
import { auth } from "../../../config/firebaseConfig";

const AvailabilityCountdown = ({
  startDate,
  endDate,
  userOverrides,
  onExpire,
}) => {
  const [timeRemaining, setTimeRemaining] = useState("");
  const currentUser = auth.currentUser;
  const hasExpired = useRef(false);
  const isSubmitting = useRef(false);

  const getRelevantDates = () => {
    if (userOverrides && currentUser && userOverrides[currentUser.uid]) {
      const override = userOverrides[currentUser.uid];
      return {
        start: new Date(override.startDate),
        end: new Date(override.endDate),
      };
    }
    return {
      start: new Date(startDate),
      end: new Date(endDate),
    };
  };

  const calculateTimeRemaining = () => {
    const now = new Date().getTime();
    const { start, end } = getRelevantDates();
    const startTime = start.getTime();
    const endTime = end.getTime();

    if (now > endTime) {
      if (!hasExpired.current && !isSubmitting.current) {
        hasExpired.current = true;
        isSubmitting.current = true;
        if (onExpire) {
          Promise.resolve()
            .then(() => onExpire())
            .finally(() => {
              isSubmitting.current = false;
            });
        }
      }
      return "Expired";
    } else if (now < startTime) {
      return null; // Return null instead of showing countdown
    } else {
      const difference = endTime - now;
      return formatTimeRemaining(difference, "Time remaining: ");
    }
  };

  const formatTimeRemaining = (difference, prefix) => {
    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((difference % (1000 * 60)) / 1000);

    return `${prefix}${days}d ${hours}h ${minutes}m ${seconds}s`;
  };

  useEffect(() => {
    if (!startDate || !endDate) return;

    const timer = setInterval(() => {
      setTimeRemaining(calculateTimeRemaining());
    }, 1000);

    setTimeRemaining(calculateTimeRemaining());

    return () => clearInterval(timer);
  }, [startDate, endDate, userOverrides]);

  if (!startDate || !endDate || !timeRemaining) return null;

  return (
    <div className="availability-countdown">
      <span className="countdown-text">{timeRemaining}</span>
    </div>
  );
};

export default AvailabilityCountdown;
